import {useRef} from 'react'
import Button from 'react-bootstrap/Button'

const FileButton = ({onChange,className,disabled})=>{
	const inputRef = useRef()
	const handleClick = ()=>{
		inputRef.current.click()
	}
	return (
		<>
			<input 
				style={{display:'none'}}
				onChange={onChange}
				ref={inputRef} 
				type="file" 
			/>
			<Button 
				disabled={disabled}
				className={[
					"text-secondary",
					className
				].join(' ')}
				onClick={handleClick}
				variant="link" 
			>
				<i className="fas fa-image"/>
			</Button>
		</>
	)
}

export default FileButton